var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h2',[_vm._v("Такой страницы не существует :(")])])])
}]

export { render, staticRenderFns }